<template>
  <div class="amazon-media-multiple-input">
    <div class="form-group row">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <draggable v-model="valArray" @end="validate(valArray)">
          <div v-for="(val, index) in valArray" :key="index">
            <div class="card mb-3">
              <div class="card-header interactive-cursor">
                <i class="far fa-fw fa-file"></i> {{ val.fileName }}
                <i class="fa fa-fw fa-bars float-right"></i>
              </div>
              <div class="card-body text-dark">
                <div class="row">
                  <div :class="hasText ? 'col-md-6 my-1 text-center' : 'col-md-12 text-center'">
                    <img v-if="val.key && val.fileType != 'pdf'" target="_blank" class="amazon-preview img-fluid" :src="'https://roscon.s3.amazonaws.com/' + val.key"/>
                  </div>
                  <div class="col-md-6 my-1" v-if="hasText">
                    <div class="tfm-textarea" @click="openTextEditor(val, index)" v-html="val.description"></div>
                  </div>
                </div>
              </div>
              <div class="card-footer text-right">
                <a :href="'https://roscon.s3.amazonaws.com/' + val.key" target="_blank" class="my-1 btn btn-primary"><i class="fa fa-search"></i> Preview Image</a>
                <button @click.prevent="deleteImage(val)" class="my-1 btn btn-danger"><i class="fa fa-trash"></i> Remove</button>
              </div>
            </div>
          </div>
        </draggable>
        <div class="upload-btn-wrapper" id="dropzone">
          <button class="btn btn-info upload-button" type="button"><i class="fa fa-plus"></i> Add Photo</button>
          <input type="hidden" :name="options.name" :id="options.name + '-url'" :value="value"/>
        </div>
        <div v-if="hasError" class="alert alert-danger my-0">
          {{ hasError }}
        </div>
        <div class="progress" style="height: 20px;" v-show="isUploading">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%' }">
            {{ progress }}%
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <div class="alert alert-info mt-4" v-if="this.hasText">
          When you upload a photo, you will be provided with a text box to enter the details about the image.
        </div>
      </div>
    </div>
    <modal
      v-if="editingText"
      :title="'Edit Description'"
      :is-open="editingText"
      @dismiss="closeModal()">
      <rich-text-input :options="editorOpts" v-model="editorOpts.value">
      </rich-text-input>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="closeModal()">
          Done
        </button>
      </div>
    </modal>
    <div class="modal-backdrop fade show" v-show="editingText"></div>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import { OPEN_MODAL, CLOSE_MODAL } from '@/vuex/types'
  import Modal from '@/components/ui/Modal'
  import RichTextInput from '@/components/inputs/RichTextInput'
  import {
    validationClass,
    validationIcon,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'TextAndFileMultipleInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      Modal,
      Draggable,
      RichTextInput
    },
    data () {
      return {
        editorOpts: {},
        progress: 0,
        editingText: false,
        isUploading: false,
        isDirty: false,
        isValid: false,
        hasError: false,
        hasText: true,
        valArray: [],
        fileTypes: {
          image: /^(image\/(gif|jpe?g|png))$/,
          pdf: /^(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
        },
        validFileType: /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/,
        invalidFileTypeError: 'Not an accepted file type. Accepted file types: JPG, PNG, GIF and PDF'
      }
    },
    computed: {
      height () {
        return this.options.height || 'auto'
      },
      width () {
        return this.options.width || 'auto'
      },
      validationClass,
      validationIcon,
      validationMessage
    },
    mounted () {
      this.valArray = this.value
      if (this.options.validFileType === 'image') {
        this.validFileType = this.fileTypes.image
        this.invalidFileTypeError = 'You must upload an image file. Accepted file types: JPG, PNG and GIF'
      } else if (this.options.validFileType === 'pdf') {
        this.validFileType = this.fileTypes.pdf
        this.invalidFileTypeError = 'You must upload a PDF file.'
      }
      if (this.options.text === false) this.hasText = false
      window.fd.logging = false
      let zone = new window.FileDrop('dropzone', {
        iframe: {
          url: `/api/admin/media-uploader?height=${this.height}&width=${this.width}`,
          fileParam: 'media',
          callbackParam: 'iframeCallback'
        }
      })
      zone.multiple(true)
      let fileName = ''
      let $vm = this
      zone.event('send', function (files) {
        $vm.isUploading = true
        files.each(function (file) {
          fileName = file.name
          $vm.hasError = false
          let uploadErrors = []
          let acceptFileTypes = $vm.validFileType
          if (file.type.length && !acceptFileTypes.test(file.type)) {
            uploadErrors.push($vm.invalidFileTypeError)
          }
          if (file.size.length && file.size > 10000000) {
            uploadErrors.push('Filesize is too big')
          }
          if (uploadErrors.length > 0) {
            $vm.progress = 0
            $vm.isUploading = false
            $vm.hasError = uploadErrors.join('\n')
          } else {
            file.event('progress', function (sent, total, xhr, event) {
              $vm.progress = parseInt(sent / total * 100, 10)
            })
            file.event('done', function (xhr) {
              $vm.progress = 0
              $vm.isUploading = false
              let values = $vm.value
              let json = JSON.parse(xhr.responseText)
              values.push({
                key: json.key,
                fileName,
                fileType: json.ext,
                description: ''
              })
              $vm.$emit('input', values)
            })
            file.event('error', function (xhr) {
              uploadErrors.push(xhr.responseText)
              $vm.hasError = uploadErrors.join('\n')
            })
            file.sendTo(`/api/admin/media-uploader?height=${$vm.height}&width=${$vm.width}`, {
              extraHeaders: true,
              method: 'POST'
            })
          }
        })
      })
      zone.event('iframeDone', function (json) {
        $vm.progress = 0
        $vm.isUploading = false
        let values = $vm.value
        values.push({
          key: json.key,
          fileName,
          fileType: json.ext,
          description: ''
        })
        $vm.$emit('input', values)
      })
      window.fd.addEvent(window.fd.byID('multiple'), 'change', function (e) {
        zone.multiple(e.currentTarget || e.srcElement.checked)
      })
      this.validate(this.value)
    },
    methods: {
      validate (val = this.value) {
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      deleteImage (image) {
        let values = this.value
        values.splice(values.indexOf(image), 1)
        this.$emit('input', values)
      },
      openTextEditor (val, index) {
        this.editorOpts = {
          index,
          name: 'textEditor',
          fullWidth: true,
          value: val.description
        }
        this.editingText = true
        this.$store.dispatch(OPEN_MODAL, {
          title: 'Edit Description',
          alreadyOpen: true
        })
      },
      async closeModal () {
        tinymce.triggerSave()
        let newDescription = tinymce.activeEditor.getContent({format: 'raw'})
        await this.$nextTick()
        let values = this.value
        values[this.editorOpts.index].description = newDescription
        this.$emit('input', values)
        this.editingText = false
        this.$store.commit(CLOSE_MODAL, 0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextAndFileMultipleInput.vue